import type { UserReplaceProfile, ReplaceProfilePayload } from '../types'
import { apiFetch } from './core'

export async function getReplaceProfiles(): Promise<UserReplaceProfile[]> {
  return apiFetch<UserReplaceProfile[]>('/api/replace-profiles')
}

export async function getActiveReplaceProfile(): Promise<UserReplaceProfile | null> {
  const result = await apiFetch<UserReplaceProfile | null>('/api/replace-profiles/active')
  return result ?? null
}

export async function createReplaceProfile(data: ReplaceProfilePayload): Promise<UserReplaceProfile> {
  return apiFetch<UserReplaceProfile>('/api/replace-profiles', { method: 'POST', body: JSON.stringify(data) })
}

export async function updateReplaceProfile(id: number, data: ReplaceProfilePayload): Promise<UserReplaceProfile> {
  return apiFetch<UserReplaceProfile>(`/api/replace-profiles/${id}`, { method: 'PUT', body: JSON.stringify(data) })
}

export async function deleteReplaceProfile(id: number): Promise<void> {
  return apiFetch<void>(`/api/replace-profiles/${id}`, { method: 'DELETE' })
}

export async function activateReplaceProfile(id: number): Promise<UserReplaceProfile> {
  return apiFetch<UserReplaceProfile>(`/api/replace-profiles/${id}/activate`, { method: 'POST' })
}

export async function deactivateAllReplaceProfiles(): Promise<void> {
  return apiFetch<void>('/api/replace-profiles/deactivate-all', { method: 'POST' })
}
